import { ProofInterface } from '@graphcommerce/graphql-mesh'
import { i18n } from '@lingui/core'
import { Button } from '@mui/material'
import { useState } from 'react'
import { HighlightButton } from '../Button/ButtonStyles'
import { ReviewProofModal } from '../Proof/ReviewProofModal'

export type ReviewProofProps = {
  proofs: ProofInterface[] | any[]
}

export function ReviewProof(props: ReviewProofProps) {
  const { proofs } = props
  const [displayProofModal, setDisplayProofModal] = useState<boolean>(false)
  const isApproved = proofs[proofs.length - 1]?.status?.toUpperCase() === 'APPROVED'
  return (
    <div className='mb-1 flex items-center justify-center lg:mb-3'>
      {isApproved && (
        <Button
          variant='outlined'
          color='primary'
          size='small'
          className='w-full rounded-[5px] bg-pure-white uppercase'
          onClick={() => setDisplayProofModal(true)}
        >
          {i18n._('Final print artwork')}
        </Button>
      )}
      {!isApproved && (
        <HighlightButton
          variant='contained'
          size='small'
          className='w-full rounded-[5px] bg-marigold uppercase'
          onClick={() => setDisplayProofModal(true)}
        >
          {i18n._('Review proof')}
        </HighlightButton>
      )}
      <ReviewProofModal
        isDisplayed={displayProofModal}
        setIsDisplayed={setDisplayProofModal}
        proofs={proofs ?? []}
      />
    </div>
  )
}
